import { defineMessages } from 'react-intl';

export default defineMessages({
  oneProductPerClaimBanner: {
    id: 'components.oneProductPerClaimBanner.info',
    defaultMessage: 'Only one product can be selected.',
  },
});
